module.exports = __webpack_public_path__ + "static/media/app-icon.76b7911f.png";